import { type ObjectMode } from '@databases/types';
import { type Database, DatabaseFieldType } from '@databases/types/database';
import {
  DatabaseCardWidth,
  DatabaseCoverFieldType,
  DatabaseLayoutType
} from '@databases/types/database/view';
import { createField, getExistingDatabase } from '@databases/utils/database/utils';

import { generateValuesForEntriesById } from '../utils';

import { databasesToContentId } from './constants';

export const getDatabaseViewOnly = (): Database<ObjectMode.EXISTING> => {
  const baseDatabase = getExistingDatabase({
    contentId: databasesToContentId['databaseViewOnly'],
    databaseName: 'Database view only'
  });

  const fields = [
    ...Array.from({ length: 3 }, (_, index) => ({
      ...createField(DatabaseFieldType.TEXT),
      name: `Text Field ${index}`
    })),
    { ...createField(DatabaseFieldType.CHECKBOX), name: 'Checkbox Field' }
  ];

  const entriesById = generateValuesForEntriesById(baseDatabase.entries, fields);

  return {
    ...baseDatabase,
    fields: fields.map((field) => field.id),
    fieldsById: Object.fromEntries(fields.map((field) => [field.id, field])),
    entriesById,
    entries: Object.keys(entriesById),
    operations: {
      delete: false,
      updateEntries: false,
      updateMetadata: false
    },
    views: [
      ...baseDatabase.views,
      {
        id: 'gallery-view',
        name: 'Gallery view',
        settings: {
          layout: {
            cardWidth: DatabaseCardWidth.MEDIUM,
            coverFieldId: DatabaseCoverFieldType.DEFAULT,
            showFieldNames: true,
            type: DatabaseLayoutType.GALLERY,
            showNumberedEntries: false
          },
          sorts: []
        }
      }
    ]
  };
};
